import parseHTML from "./dom/funciones/parse_html";
import { unaVez } from "./eventos";
var popup = parseHTML("<div class=\"popup-cookies\" role=\"banner\">\n    <div class=\"inner\">\n        <div class=\"popup-cookies-texto\">\n            Utilizamos cookies propias y de terceros para mejorar nuestros servicios.\n            Si haces clic en ACEPTAR, consideramos que aceptas su uso.\n            Puedes obtener m\u00E1s informaci\u00F3n en la \n            <a href=\"/condiciones-de-uso/\" target=\"_blank\">Pol\u00EDtica de cookies</a>.\n        </div>\n        <div class=\"popup-cookies-botones\">\n            <button class=\"popup-cookies-aceptar\">\n                Aceptar\n            </button><button class=\"popup-cookies-rechazar\">\n                Rechazar\n            </button>\n        </div>\n    </div>\n</div>");
var ocultar = function () {
    unaVez(popup, 'transitionend', function () { return popup.remove(); });
    popup.classList.remove('is-visible');
};
var cookies = function (dataLayer, texto) {
    var aceptado = localStorage.getItem('analytics'), fechaDeAceptacion = parseInt(localStorage.getItem('fechaDeAceptacion') || '0');
    if (aceptado && fechaDeAceptacion > Date.now() - 15768000000) {
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({ event: 'analytics-permitido', 'analytics-aceptado': aceptado });
    }
    else {
        document.documentElement.appendChild(popup);
        if (texto) {
            popup.querySelector('.popup-cookies-texto').innerHTML = texto;
        }
        var aceptar = popup.querySelector('.popup-cookies-aceptar'), rechazar = popup.querySelector('.popup-cookies-rechazar');
        aceptar.addEventListener('click', function () {
            localStorage.setItem('analytics', 'true');
            localStorage.setItem('fechaDeAceptacion', Date.now().toString());
            dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({ event: 'analytics-permitido', 'analytics-aceptado': 'true' });
            ocultar();
        });
        rechazar.addEventListener('click', function () {
            localStorage.setItem('analytics', 'false');
            dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({ event: 'analytics-permitido', 'analytics-aceptado': 'false' });
            ocultar();
        });
        setTimeout(function () { return popup.classList.add('is-visible'); });
    }
};
export default cookies;
